export default __webpack_public_path__ + "static/media/investment_inactive.2e740c76.svg";